/*jshint browserify: true */
'use strict';

/**
 * Translate the position in the mouseEvent to a position relative to the element.
 *
 * @return {Object} Coordinates translated to element-relative coordinates. Object has x and y properties.
 */
function translateMousePosForElement(element, mouseEvent) {
    var bounds = element.getBoundingClientRect();
    return {
        x: mouseEvent.clientX - bounds.left,
        y: mouseEvent.clientY - bounds.top
    };
}

module.exports = translateMousePosForElement;